import { Box, Tooltip, TooltipPopup, TooltipTrigger } from "@salestrak/ui";
import React from "react";

import { HotkeyTooltipLabel } from "./hotkey-tooltip-label";

/**
 * Wraps a search field so hovering it shows the field's name and the key
 * that focuses it, below the field. Hover-only, on purpose: a focus open
 * (Base UI's default) would raise the bubble the moment the field is clicked
 * — or the moment the advertised hotkey lands focus in it — and park it over
 * the very results the field filters. Focus arriving while the bubble is
 * already up from a hover closes it for the same reason.
 *
 * The trigger is a wrapper, not the input group itself: `TooltipTrigger`
 * writes its own `data-slot`, and the input group's styling keys off
 * `[data-slot=input-group]`.
 */
export function SearchFieldHotkeyTooltip({
  label,
  keys,
  children,
}: {
  label: string;
  /** Omitted while another search is the hotkey's target. */
  keys?: readonly string[] | undefined;
  children: React.ReactNode;
}) {
  const [open, setOpen] = React.useState(false);
  return (
    <Tooltip
      open={open}
      onOpenChange={(next, details) => {
        if (next && details.reason === "trigger-focus") return;
        setOpen(next);
      }}
    >
      <TooltipTrigger render={<Box onFocus={() => setOpen(false)} />}>
        {children}
      </TooltipTrigger>
      <TooltipPopup side="bottom">
        <HotkeyTooltipLabel keys={keys} label={label} />
      </TooltipPopup>
    </Tooltip>
  );
}
